import { all, AllEffect } from 'redux-saga/effects';
import UserDetailsReducer from './duck/reducer';
import { watchGetCurrentUserDetails, watchRefreshToken } from './duck/saga';

function* UserDetailsSaga(): Generator<AllEffect<Generator>> {
  yield all([watchGetCurrentUserDetails(), watchRefreshToken()]);
}

export { UserDetailsReducer, UserDetailsSaga };
